import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../language/keys';
import { style } from './style';

export const HistoryErrorMessage = ():JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Box sx={ style.container.sx }>
      <Typography variant={ style.container.Typography.title.variant }
        sx={ style.container.Typography.title.sx }
        fontWeight={ 900 }
      >
        {translate(STRING_KEYS.HISTORY_ERROR_MESSAGE_TITLE)}
      </Typography>
      <Typography variant={ style.container.Typography.text.variant }
        sx={ style.container.Typography.text.sx }
      >
        {translate(STRING_KEYS.HISTORY_ERROR_MESSAGE_TEXT)}
      </Typography>
    </Box>
  );
};
